import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

// 반응형 브레이크포인트
const breakpoints = {
  mobile: '768px',
  tablet: '1024px'
};

const FooterWrap = styled.div`
  width: 100%;
  background: #ffffff;
  border-top: 1px solid #eaeaea;
  padding: 2rem 2rem;
  margin-top: 2rem;
  
  /* 모바일 */
  @media (max-width: ${breakpoints.mobile}) {
    padding: 1.5rem 1rem;
    margin-top: 1.5rem;
  }
`;

const FooterContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  
  /* 모바일 */
  @media (max-width: ${breakpoints.mobile}) {
    max-width: none;
    width: 100%;
    text-align: center;
  }
`;

const FooterCenter = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  
  /* 모바일 */
  @media (max-width: ${breakpoints.mobile}) {
    gap: 0.75rem;
  }
`;

const CompanyInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const CompanyName = styled.div`
  font-size: 1.125rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 0.25rem;
  
  /* 모바일 */
  @media (max-width: ${breakpoints.mobile}) {
    font-size: 1rem;
  }
`;

const CompanyDetails = styled.div`
  font-size: 0.875rem;
  line-height: 1.5;
  color: #666;
  
  /* 모바일 */
  @media (max-width: ${breakpoints.mobile}) {
    font-size: 0.8rem;
    line-height: 1.6;
  }
`;

const Divider = styled.div`
  height: 1px;
  background: #eaeaea;
  margin: 1rem 0;
  
  /* 모바일 */
  @media (max-width: ${breakpoints.mobile}) {
    margin: 0.75rem 0;
  }
`;

const Copyright = styled.div`
  font-size: 0.8rem;
  color: #999;
  text-align: center;
  
  /* 모바일 */
  @media (max-width: ${breakpoints.mobile}) {
    font-size: 0.75rem;
  }
`;

const ContentContainer = styled.div`
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: pre-wrap;
  text-align: left;
`;

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <FooterWrap>
      <FooterContainer>
        <FooterCenter>
          <CompanyInfo>
            <CompanyName>(주)앤츠네스트</CompanyName>
            <CompanyDetails>
              이메일 : admin@antsnest.co.kr
              <br />
              대표자 : 용수현 | 사업자번호 : 444-86-03555
              <br />
              경기도 용인시 기흥구 강남서로 9,7층 703-제이295호
            </CompanyDetails>
          </CompanyInfo>
          
          <Divider />
          
          <Copyright>
            © ANTSNEST DEVELOPER CENTER Co.Ltd. All Rights Reserved.
          </Copyright>
        </FooterCenter>
      </FooterContainer>
    </FooterWrap>
  );
}

function Useinfo() {
  const [content, setContent] = useState('');

  useEffect(() => {
    fetch('/registerText/useinfo.txt')
      .then(response => response.text())
      .then(text => setContent(text));
  }, []);

  return (
    <ContentContainer>
      <h1>이용약관</h1>
      <div dangerouslySetInnerHTML={{ __html: content }} />
    </ContentContainer>
  );
}

function Privacy() {
  const [content, setContent] = useState('');

  useEffect(() => {
    fetch('/registerText/privacy.txt')
      .then(response => response.text())
      .then(text => setContent(text));
  }, []);

  return (
    <ContentContainer>
      <h1>개인정보취급방침</h1>
      <div dangerouslySetInnerHTML={{ __html: content }} />
    </ContentContainer>
  );
}

function Kid() {
  const [content, setContent] = useState('');

  useEffect(() => {
    fetch('/registerText/kid.txt')
      .then(response => response.text())
      .then(text => setContent(text));
  }, []);

  return (
    <ContentContainer>
      <h1>청소년보호정책</h1>
      <div dangerouslySetInnerHTML={{ __html: content }} />
    </ContentContainer>
  );
}

export { Useinfo, Privacy, Kid };
